/* eslint-disable prefer-template */
/* eslint-disable default-param-last */ import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  responseTime: 0,
  isError: false,
  msgError: '',
};
export const headcountActiveEmployeeCSVReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionType.HEADCOUNT_ACTIVE_EMPLOYEE_CSV + '_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case actionType.HEADCOUNT_ACTIVE_EMPLOYEE_CSV + '_RESULT':
      return {
        ...state,
        data: action.result.data,
        responseTime: action.result.responseTime,
        isLoading: false,
        isError: false,
        msgError: '',
      };
    case actionType.HEADCOUNT_ACTIVE_EMPLOYEE_CSV + '_FAILED':
      return {
        ...state,
        isLoading: false,
        isError: true,
        msgError: action.err,
      };
    default:
      return state;
  }
};
